
<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>生成会员兑换码</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <el-row style="text-align: left;white-space: nowrap">
          <span>已生成兑换码总数：{{excelData1.wsy+excelData1.ysy}}</span>
<!--          <el-input v-model="numValue"  :min="1" label="生成数量" style="width: 92%;margin-left: 20px"></el-input>-->
        </el-row>
        <el-row style="text-align: left;white-space: nowrap;margin-top: 20px">
          <span>生成数量</span>
          <el-input v-model="numValue"  :min="1" label="生成数量" style="width: 92%;margin-left: 20px"></el-input>
        </el-row>
       <div style="text-align: left;margin-top: 5px;color: #8c939d;font-size: 14px;margin-left: 90px"> 请填写1-200的数字</div>

        <el-button type="primary" plain @click="submit()" style="margin-top: 30px">生成</el-button>


      </el-row>
    </el-row>
    <excel-dao-chu :my-title="excelTitleData" :my-data="excelData" my-name="大师会员兑换码" :my-click="excelClick"></excel-dao-chu>

  </div>
</template>

<script>
  export default {
    name: "ExchangeCode",
    mounted() {
      if(!this.$store.state.login.in){
        this.$router.push({ name: "login", params: { userId: 123 }})

      }
      this.submit1()
    },
    data() {
      return {
        numValue:10,
        excelTitleData:['兑换码'],
        excelData:[],
        excelData1:[],
        excelClick:false,
      }
    },
    computed:{
    },
    watch:{
    },
    methods: {

      //生成兑换码
      submit(){
        this.mySelect('vipCode',{num:this.numValue}).then(data=>{
           this.excelData=data
          this.excelClick=true
        })
      },
 //生成兑换码总数
      submit1(){
        this.mySelectAll('vipCodeCount').then(data=>{
           this.excelData1=data.data
          console.log(data.data)
        })
      },

    }
  }
</script>

<style scoped>
  .admin-body{
    /*background-color: white;*/
    width: 100%;
  }
  .main{
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/page/user/ExchangeCode.vue